module.exports = __webpack_public_path__ + "media/Loops Pad.62f4e524.wav";